/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BonusBatchGrantResultVo } from './BonusBatchGrantResultVo';
import {
    BonusBatchGrantResultVoFromJSON,
    BonusBatchGrantResultVoFromJSONTyped,
    BonusBatchGrantResultVoToJSON,
    BonusBatchGrantResultVoToJSONTyped,
} from './BonusBatchGrantResultVo';

/**
 * 
 * @export
 * @interface ResponseBonusBatchGrantResultVo
 */
export interface ResponseBonusBatchGrantResultVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBonusBatchGrantResultVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBonusBatchGrantResultVo
     */
    message?: string;
    /**
     * 
     * @type {BonusBatchGrantResultVo}
     * @memberof ResponseBonusBatchGrantResultVo
     */
    data?: BonusBatchGrantResultVo;
}

/**
 * Check if a given object implements the ResponseBonusBatchGrantResultVo interface.
 */
export function instanceOfResponseBonusBatchGrantResultVo(value: object): value is ResponseBonusBatchGrantResultVo {
    return true;
}

export function ResponseBonusBatchGrantResultVoFromJSON(json: any): ResponseBonusBatchGrantResultVo {
    return ResponseBonusBatchGrantResultVoFromJSONTyped(json, false);
}

export function ResponseBonusBatchGrantResultVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBonusBatchGrantResultVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BonusBatchGrantResultVoFromJSON(json['data']),
    };
}

export function ResponseBonusBatchGrantResultVoToJSON(json: any): ResponseBonusBatchGrantResultVo {
    return ResponseBonusBatchGrantResultVoToJSONTyped(json, false);
}

export function ResponseBonusBatchGrantResultVoToJSONTyped(value?: ResponseBonusBatchGrantResultVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BonusBatchGrantResultVoToJSON(value['data']),
    };
}

